exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1Psf6WK7R-fxc7TungoqAd{position:fixed;top:0;bottom:0;left:0;right:0;z-index:5;background-color:hsla(0,0%,100%,.65)}._1BUR2AhCSXCXe9wWBbGzjt{position:fixed;top:25%;left:35%;right:35%;background-color:#454579;color:#fff;z-index:5;border-radius:15px;padding:2em;box-sizing:border-box}span._3h6JKcwJaE2RdQxPNyKoju{position:absolute;top:10px;right:12px;transform:scale(1.8);cursor:pointer}@media screen and (max-width:900px){._1BUR2AhCSXCXe9wWBbGzjt{left:10%;right:10%}}", ""]);

// exports
exports.locals = {
	"overlay": "_1Psf6WK7R-fxc7TungoqAd",
	"box": "_1BUR2AhCSXCXe9wWBbGzjt",
	"closeModal": "_3h6JKcwJaE2RdQxPNyKoju"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Alert/Alert.scss
 ** module id = 306
 ** module chunks = 0
 **/